<template>
	<v-expansion-panels v-model="panel" flat accordion>
		<ExpansionPanel :title="'Basics'">
			<SettingSwitch
				:title="'Label'"
				:placeholder="'Type your title here'"
				:switchValue.sync="titleEnabled"
				:textFieldValue.sync="titleValue"
			/>
			<SettingSwitch :title="'Prefill'" :switchValue.sync="prefillEnabled" />
			<div class="align-center mb-4 prefill-row display-flex flex-row width-100" v-if="prefillEnabled">
				<div class="width-100">
					<CombinedInputFieldDataMenu
						:textAreaMode="false"
						:value.sync="prefillValue"
						:attachTo="'.prefill-row'"
						:valuesTypes="dataInputMenuValueTypes"
					/>
				</div>
			</div>
			<SettingSwitch :title="'Required'" :switchValue.sync="requiredEnabled" />
		</ExpansionPanel>
		<ExpansionPanel :title="'Explanations'">
			<SettingSwitch
				:title="'Description'"
				:placeholder="'Type your description here'"
				:switchValue.sync="descriptionEnabled"
				:textFieldValue.sync="descriptionValue"
			/>
			<SettingSwitch
				:title="'Placeholder'"
				:placeholder="'Type placeholder text'"
				:switchValue.sync="placeholderEnabled"
				:textFieldValue.sync="placeholderValue"
			/>
		</ExpansionPanel>

		<ExpansionPanel :title="'Formatting'">
			<v-row no-gutters class="align-center" v-for="option in fieldOptions[0].items" :key="option.key">
				<v-col cols="12" v-if="option.type == 'select'">
					<h3 class="gr">{{ option.name }}</h3>
					<v-select
						class="slct"
						outlined
						dense
						:items="option.options"
						item-value="value"
						item-text="text"
						:value="localField.metadata.output[option.key]"
						@input="(v) => updateOutput(option.key, v)"
					></v-select>
				</v-col>
				<v-col cols="12" v-else>
					<v-row>
						<v-col>
							<h3 class="light">{{ option.name }}</h3>
						</v-col>
						<v-col>
							<v-text-field
								hide-details
								outlined
								class="ac"
								:value="localField.metadata.output[option.key]"
								@input="(v) => updateOutput(option.key, v)"
								height="40"
								:placeholder="option.placeholder"
							></v-text-field>
						</v-col>
					</v-row>
				</v-col>
			</v-row>
		</ExpansionPanel>
		<ExpansionPanel :title="'Validation'">
			<v-row no-gutters class="align-center" v-for="option in fieldOptions[1].items" :key="option.key">
				<v-col v-if="option.optional">
					<v-checkbox
						dense
						color="primary"
						:inputValue="localField.metadata.validations[option.key].enabled"
						@change="(v) => updateValidationEnabled(option.key, v)"
					>
						<template v-slot:label>
							<h3 class="light" style="line-height: 16px">{{ option.name }}</h3>
						</template>
					</v-checkbox>
				</v-col>
				<v-col cols="auto" class="text-right">
					<v-text-field
						style="width: 90px"
						hide-details
						type="number"
						:value="localField.metadata.validations[option.key].value"
						@input="(v) => updateValidationValue(option.key, v)"
						outlined
						class="ac"
						height="40"
						:placeholder="option.placeholder"
					></v-text-field>
				</v-col>
			</v-row>
		</ExpansionPanel>
	</v-expansion-panels>
</template>

<script>
import SettingSwitch from './WidgetSettings/SettingSwitch';
import ExpansionPanel from './WidgetSettings/ExpansionPanel';
import ItemOnlyAllowedValueTypesMixin from './ValueTypesMixins/ItemOnlyAllowedValueTypesMixin';
import FieldSettingsMixin from '@/components/BlockEditorWidget/FieldSettings/FieldSettingsMixin';

export default {
	name: 'NumberInputFieldSettings',
	mixins: [FieldSettingsMixin, ItemOnlyAllowedValueTypesMixin],
	components: {
		SettingSwitch,
		ExpansionPanel,
	},
	computed: {
		fieldOptions() {
			//demo data
			return [
				{
					id: 2,
					name: 'Styling',
					items: [
						{
							key: 'thousands_seperator',
							name: 'Thousands separator',
							type: 'select',
							options: [
								{
									value: ',',
									text: ', (100,000)',
								},
								{
									value: '.',
									text: '. (100.000)',
								},
							],
						},
						{
							key: 'decimal_seperator',
							name: 'Decimal separator',
							type: 'select',
							options: [
								{
									value: ',',
									text: ', (1,00)',
								},
								{
									value: '.',
									text: '. (1.00)',
								},
							],
						},
						{
							key: 'prefix',
							name: 'Prefix',
						},
						{
							key: 'suffix',
							name: 'Suffix',
						},
					],
				},
				{
					id: 3,
					name: 'Data validation',
					items: [
						{
							key: 'decimal',
							name: 'Allow decimal points',
							optional: true,
						},
						{
							key: 'min_number',
							name: 'Number must be bigger than',
							optional: true,
						},
						{
							key: 'max_number',
							name: 'Number must be smaller than',
							optional: true,
						},
					],
				},
			];
		},
		fieldStyle() {
			// return this.field.style

			//demo data
			return [
				{
					key: 'outline',
					name: 'Outline color',
					optional: true,
				},
				{
					key: 'background',
					name: 'Background color',
					optional: true,
				},
			];
		},
	},
	methods: {
		updateOutput(optionKey, value) {
			this.setLocalFieldKey(`metadata.output.${optionKey}`, value);
		},
	},
};
</script>
